<h3>{{ title }}</h3>

<div class="form-control">
  <label class="text-neutral-900">{{ nameLabel }}</label>
  <input
    [(ngModel)]="name"
    autocomplete="off"
    [placeholder]="namePlaceholder"
    type="text">
</div>

<div class="form-control">
  <label class="text-neutral-900">{{ descriptionLabel }}</label>
  <textarea
    [(ngModel)]="description"
    autocomplete="off"
    class="w-full rounded-lg border border-[var(--color-neutral-300)] bg-neutral px-3 py-2 cd-text-b4"
    [placeholder]="descriptionPlaceholder"
    rows="3"></textarea>
</div>

@if (errorMessage) {
  <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
}

<div class="w-full flex flex-row items-center gap-3 mt-2">
  <button (click)="save()" class="btn btn-primary" type="button">
    {{ saveText }}
  </button>
  <button (click)="close()" class="btn btn-primary-soft" type="button">
    {{ cancelText }}
  </button>
</div>
